export default __webpack_public_path__ + "static/media/background_viewResponsable_cotisation.3b998cbc.jpg";